import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { SearchFilter } from '../../../common/search-filter';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { REDUCER_NAME, setCode } from '../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import IndexSummary from './../../common/index-summary';
import memoize from 'fast-memoize';
import './searchbox.scss';

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.memoizeGetListSearchFromRedux = memoize(this.getListSearchFromRedux);
  }

  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, setCode, componentId } = this.props;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      data.search.isIndex ||
      data.search.isDerivatives ||
      !data.search.isTicker
    ) {
      return;
    }
    setCode(data.search, componentId);
  };

  onChangeCurrentSearch = data => {
    const { componentId, setCode, syncType } = this.props;
    setCode(data, componentId);

    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: data,
    });
  };

  getListSearchFromRedux = organizations => {
    return organizations.filter(item => {
      return item.comTypeCode !== 'QU';
    });
  };

  render() {
    let {
      currentSearch,
      latestPrice,
      listOrganizationByOrganCode,
    } = this.props;
    const priceData = {
      MatchPrice: latestPrice.matchPrice,
      PriceChange: latestPrice.priceChange,
      PercentPriceChange: latestPrice.percentPriceChange,
      ReferencePrice: latestPrice.referencePrice,
      FloorPrice: latestPrice.floorPrice,
      CeilingPrice: latestPrice.ceilingPrice,
    };

    return (
      <div className="search-box-wrapper">
        <SearchFilter
          schema={[
            { key: 'displayCode', className: 'w-20' },
            { key: 'codeName', className: 'w-55 text-truncate' },
            {
              key: 'exchange',
              className: 'w-25 text-right',
              render: text => text.toUpperCase(),
            },
          ]}
          listKeyFilter={['displayCode', 'codeName']}
          getListSearchFromRedux={state =>
            this.memoizeGetListSearchFromRedux(
              state[COMMON_REDUCER_NAME].listOrganizationSearch,
            )
          }
          clickItemSearch={this.onChangeCurrentSearch}
          currentSearch={
            listOrganizationByOrganCode[currentSearch.code] || currentSearch
          }
          mainKey={'code'}
          sortKey={'displayCode'}
          customWidth={170}
        />
        <IndexSummary topContent={priceData} />
      </div>
    );
  }
}

SearchBox.propTypes = {
  setCode: PropTypes.any,
  currentSearch: PropTypes.any,
  latestPrice: PropTypes.any,
  componentId: PropTypes.any,
  listOrganizationByOrganCode: PropTypes.any,
};

const mapStateToProps = (state, { componentId, componentName }) => ({
  currentSearch: state[REDUCER_NAME][componentId].currentSearch,
  latestPrice: state[REDUCER_NAME][componentId].latestPrice,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

const mapDispatchToProps = {
  setCode,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(SearchBox);
